
import filters from "@/filters";
import Vue from "vue";
import Component from "vue-class-component";
import { Action, State } from "vuex-class";
import { ENUM_JOB_VACANCY_STATUS } from "@/constants/enum.constant";

import PaginationMiniComponent from "@/components/paginations/PaginationMini.vue";

@Component({
  components: {
    PaginationMiniComponent
  },
  filters
})
export default class Job extends Vue {
  /* VUEX */

  // ACTION
  @Action("actionSelectEmployerVacancy", { namespace: "employer" })
  private actionSelectEmployerVacancy: any;
  @Action("actionPaginationEmployerVacancy", { namespace: "employer" })
  private actionPaginationEmployerVacancy: any;
  @Action("actionSelectJobCategoryUnpaged", { namespace: "job" })
  private actionSelectJobCategoryUnpaged: any;
  @Action("actionSelectJobSpecializationUnpaged", { namespace: "job" })
  private actionSelectJobSpecializationUnpaged: any;
  @Action("actionSelectEmploymentTypeUnpaged", { namespace: "employer" })
  private actionSelectEmploymentTypeUnpaged: any;

  // STATE
  @State("locale")
  private locale: string;
  @State("array_vacancy", { namespace: "employer" })
  private array_vacancy: any;
  @State("pagination_vacancy", { namespace: "employer" })
  private pagination_vacancy: any;
  @State("array_job_category", { namespace: "job" })
  private array_job_category: any;
  @State("array_job_specialization", { namespace: "job" })
  private array_job_specialization: any;
  @State("array_employment_type", { namespace: "employer" })
  private array_employment_type: any;

  /* INITIALIZATION */

  private enumJobVacancyStatus: any = ENUM_JOB_VACANCY_STATUS;
  private statusOptions: any[] = [
    {
      value: 1,
      name: "Not Published",
      translation: "Tidak Diterbitkan"
    },
    {
      value: 2,
      name: "Active",
      translation: "Aktif"
    },
    {
      value: 3,
      name: "Inactive",
      translation: "Tidak Aktif"
    }
  ];
  private searchParams: any = {
    job_category: null,
    job_title: null,
    status: null,
    employment_type: null,
    period_from: null,
    period_to: null
  };

  constructor() {
    super();
  }

  /* LIFECYCLE */

  private created() {
    this.actionSelectEmployerVacancy({ params: this.searchParams });
    this.actionSelectJobCategoryUnpaged();
    this.actionSelectJobSpecializationUnpaged();
    this.actionSelectEmploymentTypeUnpaged();
  }

  /* METHOD */

  private getOptionLabel(option: any) {
    if (typeof option === "object") {
      if (this.locale === "en") {
        return option["name"] ? option["name"] : option["translation"];
      } else {
        return option["translation"] ? option["translation"] : option["name"];
      }
    }
    return option;
  }

  private clickPage(page: number, url: string) {
    if (url) {
      this.actionPaginationEmployerVacancy({ page, url });
    } else {
      this.actionSelectEmployerVacancy();
    }
  }

  private getLabel(label: string): string {
    if (this.locale === "id") {
      return "translation";
    }
    return label;
  }

  private getLabelTranslation(label: string): string {
    if (this.locale === "id") {
      return "label_translation";
    }
    return label;
  }
}
